import AxiosFoundationAPI from "../../../../util/AxiosFoundationAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";
import {V1ObjectRelationshipTypeIDOCToArray} from "../../../../util/Payload";

// The kinds of edge an object may have -- "is a component of", "supersedes" -- each naming itself
// from both ends, so one row reads correctly whichever object you are standing on.
//
// READ ONLY HERE. Relationship types are configuration: they are administered on their own screen,
// and a record's detail page only ever picks from them.
const URL = "t1/v1/object_relationship_types";
const IDOC = "v1.ObjectRelationshipType-001";

class ObjectRelationshipTypeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        const idocResponse = this.getIDOCResponse() ?? IDOC;

        const QBE = {
            "PlatformMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "ObjectRelationshipType": {
                    "_attributes": {
                        "limit": pageSize,
                        "sort": this.getFormattedSortSpecification(),
                        "offset": (page - 1) * pageSize,
                    },
                    "QueryGroups": {
                        "QueryGroup": [{
                            "Name": "primary",
                            "Operator": "AND",
                            "Type": "QueryGroup",
                            "Membership": {"Member": []},
                        }],
                    },
                },
            },
        };

        AxiosFoundationAPI({
            method: "GET",
            url: URL,
            json: true,
            params: {"QBE": btoa(JSON.stringify(QBE))},
            headers: {"idoc-response": idocResponse},
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ObjectRelationshipTypeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ObjectRelationshipTypeEnterpriseComponent;
